import React from 'react';
import { Section, SectionTitle } from '../../../components/TwoColumnLayout';
import { Link } from 'react-router-dom';
import { Icon } from '../../../components/Icon';
import styled from 'styled-components';

interface Props {
	customerBillingData: any
}

const Container = styled.div`
  padding-top: 1rem;
    input {
    width: 250px;
  }
	
	&::after {
		content: "";
		clear: both;
		display: table;
	}

  input[type="text"] {
    min-width: 450px;
  }

  .info{
    width: 200px;
    font-size: 1rem;
    padding-left: 1rem;
    // border: 1px solid red;
  }

  .grayInfo{
    font-size: 1rem;
    color: darkgray;
  }
`;

const LeftAlign = styled.div`
  float:left;
  //border: 1px solid red;
`;

const RightAlign = styled.div`
  //border: 1px solid green;
  padding-top: 1rem;
  overflow: hidden; /* if you don't want #second to wrap below #first */

  .info{
    float: right;
    color: red;
  }
`;

export const PaymentInfo: React.FC<Props> = (props: Props) => {
	return (
		<div>
		<SectionTitle>Maksutapa</SectionTitle>
		<Section>
		  <Container>
			<LeftAlign>
			  <div className="info">
				<p>Lasku sähköpostiin</p>
				<input
				  // TODO: address list should be all rendered, not just first item. Not supported feature?
				  value={props.customerBillingData.addresses ? props.customerBillingData.addresses[0].emailAddress : 'Tietoa ei saatavilla'}
				  type="text"
				  readOnly
				/>
			  </div>
			</LeftAlign>
			<RightAlign>
			  <div className="info">
				<Link to={'/account/editBillingEmail'} className={"edit-link-btn"}>
				  <Icon name="small--edit" />
				  <p>Vaihda osoitetta</p>
				</Link>
			  </div>
			</RightAlign>
		  </Container>
		</Section>
	  </div>
	);
};